import React, { createContext, useContext, useEffect, useState } from 'react';

import { refreshToken } from '../helpers/';

const HookContext = createContext({});

export function RefreshTokenProvider({ children }: any) {
  let [refresh, setRefresh] = useState(true);

  useEffect(() => {
    // console.log('Performance: RefreshTokenProvider');
    const requestNewToken = async () => {
      await refreshToken();
      setRefresh(false);
    };
    requestNewToken();
  }, []);

  return (
    <HookContext.Provider value={{}}>
      {refresh ? null : <>{children}</>}
    </HookContext.Provider>
  );
}

export const useRefreshToken = () => {
  const context = useContext(HookContext);
  return context;
};
